// import './sass/01_basis/index.scss';
import './sass/02_layout/index.scss';
import './sass/03_plugins/index.scss';
// import './sass/03_plugins/index.scss';
// import './sass/02_layout/impact.scss';

console.log('okokokoko');

import './js/header_size_on_scroll.js';
import './js/intro.js';
// import './js/cover_caroussel.js';

// import './js/script.js';
// // mainscript